import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Table from "react-bootstrap/Table";
import { Col, Container, Row } from "react-bootstrap";
import { BsFillCalculatorFill } from "react-icons/bs";
import { useAuth } from "../context/AuthContext";

export const TrustInvoiceSettingsModal = ({
  visible,
  close,
  trust,
  onComplete,
}) => {
  const { authAxios } = useAuth();
  const [saving, setSaving] = useState(false);

  const [invoiceAddress, setInvoiceAddress] = useState("");
  const [invoicePrefix, setInvoicePrefix] = useState("");
  const [invoiceEmailDestination, setInvoiceEmailDestination] = useState("");
  const [digitalInvoicing, setDigitalInvoicing] = useState(false);
  const [invoiceCounter, setInvoiceCounter] = useState(0);
  const [sageAccountReference, setSageAccountReference] = useState("");
  const [sageNominalCode, setSageNominalCode] = useState("");
  const [sageDepartmentCode, setSageDepartmentCode] = useState("");
  const [sageVatCode, setSageVatCode] = useState("");
  const [sageVat, setSageVat] = useState("");

  useEffect(() => {
    if (!trust) return;
    setInvoiceAddress(trust.invoiceAddress || "");
    setInvoicePrefix(trust.invoicePrefix || "");
    setInvoiceEmailDestination(trust.invoiceEmailDestination || "");
    setDigitalInvoicing(trust.digitalInvoicing || false);
    setInvoiceCounter(trust.invoiceCounter || 0);
    setSageAccountReference(trust.sageAccountReference || "");
    setSageNominalCode(trust.sageNominalCode || "");
    setSageDepartmentCode(trust.sageDepartmentCode || "");
    setSageVatCode(trust.sageVatCode || "");
    setSageVat(trust.sageVat || "");
  }, [trust]);

  const save = async () => {
    try {
      setSaving(true);
      const response = await authAxios().put(
        `/api/backoffice/invoice/trust_settings/${trust.id}`,
        {
          invoiceAddress,
          invoicePrefix,
          invoiceEmailDestination,
          digitalInvoicing,
          invoiceCounter,
          sageAccountReference,
          sageNominalCode,
          sageDepartmentCode,
          sageVatCode,
          sageVat,
        },
      );
      onComplete(response.data);
    } catch (error) {
      console.log(error);
      alert("Failed to save invoice settings");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal show={visible} onHide={close} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title className={"text-axis-offblack icon-text-wrapper"}>
          <h1 className={"text-axis-offblack icon-text-wrapper"}>
            <BsFillCalculatorFill /> Invoice Settings — {trust?.shortName}
          </h1>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Table striped hover responsive>
          <tbody>
            <tr>
              <td style={{ width: "35%" }}>Digital Invoicing</td>
              <td>
                <Form.Check
                  type="switch"
                  checked={digitalInvoicing}
                  onChange={(e) => setDigitalInvoicing(e.target.checked)}
                  label={digitalInvoicing ? "Enabled" : "Disabled"}
                />
              </td>
            </tr>
            <tr>
              <td colSpan={2}>
                <strong>Sage Settings</strong>
              </td>
            </tr>
            <tr>
              <td>Sage Account Reference</td>
              <td>
                <Form.Control
                  value={sageAccountReference}
                  onChange={(e) => setSageAccountReference(e.target.value)}
                  size="sm"
                  placeholder="e.g. BHSCT"
                />
              </td>
            </tr>
            <tr>
              <td>Sage Nominal Code</td>
              <td>
                <Form.Control
                  value={sageNominalCode}
                  onChange={(e) => setSageNominalCode(e.target.value)}
                  size="sm"
                  placeholder="e.g. 4000"
                />
              </td>
            </tr>
            <tr>
              <td>Sage Department Code</td>
              <td>
                <Form.Control
                  value={sageDepartmentCode}
                  onChange={(e) => setSageDepartmentCode(e.target.value)}
                  size="sm"
                  placeholder="e.g. 0"
                />
              </td>
            </tr>
            <tr>
              <td>Sage VAT Code</td>
              <td>
                <Form.Control
                  value={sageVatCode}
                  onChange={(e) => setSageVatCode(e.target.value)}
                  size="sm"
                  placeholder="e.g. T9"
                />
              </td>
            </tr>
            <tr>
              <td>Sage VAT</td>
              <td>
                <Form.Control
                  value={sageVat}
                  onChange={(e) => setSageVat(e.target.value)}
                  size="sm"
                  placeholder="e.g. 0"
                />
              </td>
            </tr>
            <tr>
              <td colSpan={2}>
                <strong>Invoice Settings</strong>
              </td>
            </tr>
            <tr>
              <td>Invoice Prefix</td>
              <td>
                <Form.Control
                  value={invoicePrefix}
                  onChange={(e) => setInvoicePrefix(e.target.value)}
                  size="sm"
                  placeholder="e.g. Bel"
                />
              </td>
            </tr>
            <tr>
              <td>Invoice Counter</td>
              <td>
                <Form.Control
                  type="number"
                  value={invoiceCounter}
                  onChange={(e) =>
                    setInvoiceCounter(parseInt(e.target.value) || 0)
                  }
                  size="sm"
                  min={0}
                />
              </td>
            </tr>
            <tr>
              <td>Invoice Email Destination</td>
              <td>
                <Form.Control
                  type="email"
                  value={invoiceEmailDestination}
                  onChange={(e) => setInvoiceEmailDestination(e.target.value)}
                  size="sm"
                  placeholder="invoices@trust.nhs.uk"
                />
              </td>
            </tr>
            <tr>
              <td>Invoice Address</td>
              <td>
                <Form.Control
                  as="textarea"
                  rows={5}
                  value={invoiceAddress}
                  onChange={(e) => setInvoiceAddress(e.target.value)}
                  size="sm"
                  placeholder={
                    "Nurse Bank Office\nTrust Name\nPO Box 1234\nCity\nBT1 1AA"
                  }
                />
              </td>
            </tr>
          </tbody>
        </Table>
      </Modal.Body>
      <Modal.Footer className="mb-0 pb-0">
        <Container fluid>
          <Row className="mb-3 align-content-center">
            <Col>
              <Button variant="secondary" className="w-100" onClick={close}>
                Cancel
              </Button>
            </Col>
            <Col>
              <Button
                className={"shift-button-approve icon-text-wrapper justify-content-center w-100"}
                onClick={save}
                disabled={saving}
              >
                {saving ? "Saving…" : "Save"}
              </Button>
            </Col>
          </Row>
        </Container>
      </Modal.Footer>
    </Modal>
  );
};
